import React, { Fragment, useEffect, useState } from 'react';
export function Countdown() {
  const [seconds, setSeconds] = useState(85947);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(value - 1, 0)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: [string, number][] = [['HOURS', Math.floor(seconds / 3600)], ['MINUTES', Math.floor(seconds % 3600 / 60)], ['SECONDS', seconds % 60]];
  return <div className="flex justify-center gap-2 sm:gap-4" aria-label="The launch offer ends soon" data-id="element-248" data-mp="1oh6l8r31vgmw">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-249" data-mp="1xh34gd6o7nak" data-mpi={index}>
          {index > 0 && <span className="pt-3 font-display text-2xl font-black text-gold/60 sm:pt-4 sm:text-4xl" data-id="element-250" data-mp="1tegao6qfvsaq">
              :
            </span>}
          <div className="min-w-[76px] rounded-xl border border-gold/40 bg-charcoal px-3 py-2.5 text-center sm:min-w-[104px] sm:px-5 sm:py-3" data-id="element-251" data-mp="38tvu9ifwi1nz">
            <div className="font-display text-3xl font-black leading-none text-gold sm:text-5xl" data-id="element-252" data-mp="34vy86ohffvot">
              {String(value).padStart(2, '0')}
            </div>
            <div className="mt-1 text-[10px] font-extrabold tracking-wider text-ivory/70" data-id="element-253" data-mp="2h56vl5306dqb">{label}</div>
          </div>
        </Fragment>)}
    </div>;
}